import axios, { AxiosResponse } from "axios";
import { resolveBackendUrl } from "./resolveBackendUrl";

// gesetzt (auch leer) gewinnt; nur undefined fällt auf den Dev-Default durch.
export const backendUrl = resolveBackendUrl(
  typeof __VITE_BACKEND_URL__ !== 'undefined' ? __VITE_BACKEND_URL__ : undefined,
  import.meta.env.VITE_BACKEND_URL,
);

const instance = axios.create({
  baseURL: backendUrl
});

function returnResponse(response: AxiosResponse) {
  return response.data;
}

instance.interceptors.response.use(returnResponse, null);

export default instance;
